
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmUnacknowledgedIec as ObiAlarmUnacknowledgedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-unacknowledged-iec.js';
 
 
 

 
 export const ObiAlarmUnacknowledgedIec = createComponent({
   react: React,
   tagName: 'obi-alarm-unacknowledged-iec',
   elementClass: ObiAlarmUnacknowledgedIecElement,
   events: {
     
   }
  });
 
 